import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {
                'en': {
                    madeBy:"Made with",
                    for:"by",
                    textIam:"I'M",
                    aboutMe:"ABOUT ME",
                    briefcase:"My briefcase",
                    textAboutMe:`I am self-taught, responsible and always wanting to know new technologies. 
                    I think that knowledge must be passed because the one who teaches learns twice. 
                    I am interested in data science, distributed systems, and databases. 
                    In my spare time I read books, articles and news about current events, given that a 
                    professional must be upright, not only interested in his area of knowledge 
                    but also in the environment that surrounds him.`,
                    technologies:"Technologies",
                    textTechnologies:`As time has gone by, I have learned to use the following tools in 
                    building software projects`,
                    experienceTitle:`Companies I have worked for`,
                    experienceDescription:`Below I show you a timeline of all the companies I have worked for`,
                    timeline_data: [
                        {
                            color: 'pink',
                            year: 'Feb 2014-Jan 2016',
                            title: 'Cobra Products',
                            description: `In this company I was a junior web developer, I built applications for 
                            android, deployed web pages in shared hosting and vps in addition to designing templates 
                            for moodle`
                        },
                        {
                            color: 'blue',
                            year: 'Feb 2016-Dec 2017',
                            title: 'MD Cloud Practice Solutions',
                            description: `At MD Cloud PS I had a role as Junior DBA and web developer. I built several 
                            analytics modules, generated queries in multiple database servers and participated in the 
                            implementation of mongo DB focused on storing information for reports`
                        },
                        {
                            color: 'blue',
                            year: 'Jan 2018-Jul 2018',
                            title: 'CareCloud SAS',
                            description: `CareCloud gave me the opportunity to be a senior software developer on a 
                            project for the hotel industry in England. I also participated in the construction of a 
                            dating web app and gave technical support to various projects.`
                        },
                        {
                            color: 'purple',
                            year: 'Jul 2018-Sep 2019',
                            title: 'Memorial International',
                            description: `In this company I participated in several projects such as a web directory 
                            to view the companies associated with Memorial, a web app for the sale of insurance 
                            policies, in addition to providing support to various apps developed by the company.`
                        },
                        {
                            color: 'black',
                            year: 'Oct 2019-Apr 2020',
                            title: 'Insoftar SAS',
                            description: `In Insoftar I contributed in several web applications as a frontend and 
                            backend developer. In addition to being a developer, I was a git master in multiple 
                            projects, which allowed me to strengthen my knowledge of git and infrastructure with AWS.`
                        },
                        {
                            color: 'green',
                            year: 'May 2020-Aug 2020',
                            title: 'MO Tecnologías',
                            description: `At MO tecnologias I had a role as Senior frontend developer, I participated 
                            in the construction of multiple web applications for the financial and credit sector. In 
                            addition to having a role as Senior frontend, I was the team leader and learned about 
                            the deployment of applications on AWS and gitlab.`
                        },
                        {
                            color: 'pink',
                            year: 'Sep 2020-Present',
                            title: 'Merqueo',
                            description: `In Merqueo I have the role of frontend developer. Some of my tasks are 
                            to support existing projects such as the marketing web platform, the construction of 
                            web interfaces using technologies such as Nuxt.js, React and Tailwind.css. It is a 
                            great place to work and I gain new knowledge every day.`
                        }
                    ]
                },
                'es': {
                    madeBy:"Hecho con",
                    for:"por",
                    textIam:"SOY",
                    aboutMe:"SOBRE MI",
                    briefcase:"Mi portafolio",
                    textAboutMe:`Soy autodidacta, responsable y con ganas de conocer nuevas tecnologías siempre. 
                    Pienso que el conocimiento debe pasarse porque el que enseña aprende 2 veces. 
                    Estoy interesado en la ciencia de los datos, los sistemas distribuidos y las bases de datos. 
                    En mis tiempos libres leo libros, artículos y noticias sobre la actualidad dado que un profesional 
                    debe ser integro, no solo interesarse por su area de conocimiento sino por el entorno que lo rodea.`,
                    technologies:"Tecnologías",
                    textTechnologies:`A medida que ha pasado el tiempo, he aprendido a usar las siguientes herramientas en 
                    la construcción de proyectos de software`,
                    experienceTitle:`Empresas para las que he trabajado`,
                    experienceDescription:`A continuación les muestro una linea de tiempo de todas las empresas 
                    en las que he trabajado`,
                    timeline_data: [
                        {
                            color: 'pink',
                            year: 'Feb 2014-Ene 2016',
                            title: 'Productos Cobra',
                            description: `En está empresa yo fui desarrollador web junior, construi aplicaciones 
                            para android, desplegue paginas web en hosting compartido y vps ademas de maquetar 
                            plantillas para moodle`
                        },
                        {
                            color: 'blue',
                            year: 'Feb 2016-Dic 2017',
                            title: 'MD Cloud Practice Solutions',
                            description: `En MD Cloud PS tuve un rol como DBA Junior y desarrollador web. Construí 
                            varios modulos de analytics, genere consulta en multiples servidores de base de datos
                            y participe en la implementación de mongo DB enfocado al almacenamiento de la información
                            para los reportes`
                        },
                        {
                            color: 'blue',
                            year: 'Ene 2018-Jul 2018',
                            title: 'CareCloud SAS',
                            description: `CareCloud me dió la oportunidad de ser desarrollador de software senior en 
                            un proyecto para el sector hotelero de Inglaterra. También participé en la construcción 
                            de una app web para citas y di soporte tecnico de varios proyectos`
                        },
                        {
                            color: 'purple',
                            year: 'Jul 2018-Sep 2019',
                            title: 'Memorial International',
                            description: `En esta empresa participé en varios proyectos como un directorio web para
                             visualizar las empresas asociadas a Memorial, una app web para la venta de polizas de 
                             seguros, además de brindar soporte a varias apps desarrollados por la empresa.`
                        },
                        {
                            color: 'black',
                            year: 'Oct 2019-Abr 2020',
                            title: 'Insoftar SAS',
                            description: `En Insoftar contribuí en varias aplicaciones web como desarrollador 
                            Frontend y backend. Además de ser desarrollador, fui git master en multiples proyectos, 
                            lo que me permitió fortalecer mi conocimiento en git e infraestructura con AWS.`
                        },
                        {
                            color: 'green',
                            year: 'May 2020-Ago 2020',
                            title: 'MO Tecnologías',
                            description: `En MO tecnologias tuve un rol como desarrollador frontend Senior, 
                            participé en la construcción de multiples aplicaciones web del sector financiero 
                            y crediticio. Además de tener un rol como Senior frontend, fui lider del equipo y 
                            aprendi sobre el despliegue de aplicaciones en AWS y gitlab.`
                        },
                        {
                            color: 'pink',
                            year: 'Sep 2020-Presente',
                            title: 'Merqueo',
                            description: `En Merqueo tengo el rol de desarrollador frontend. Algunas de mis tareas son dar 
                            soporte a proyectos existentes como la plataforma web de merqueo, la construcción 
                            de interfaces web utilizando tecnologias como Nuxt.js, React y Tailwind.css. 
                            Es un gran lugar para trabajar y adquiero nuevos conocimientos cada dia.`
                        }
                    ]
                }};

const i18n = new VueI18n({ locale: 'en', // set locale  
                fallbackLocale: 'es', // set fallback locale    
                messages, // set locale messages
            });

export default i18n;